import script from "./ServiceTemplateStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServiceTemplateStep.vue?vue&type=script&setup=true&lang=ts"

import "./ServiceTemplateStep.vue?vue&type=style&index=0&id=fc8e3848&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc8e3848"]])

export default __exports__